import {
  $,
  $$,
  closest,
  getTopPosition,
  whichTransitionEvent,
} from 'utils/dom';
import { splitByCondition } from 'utils/helper';
import Shower from 'modules/shower';
import aniScroll from 'modules/ani-scroll';
import Bus from 'modules/event-bus';
const transitionEndEvent = whichTransitionEvent();
class JumpMarks {
  STICKY_CLASS = 'is-stuck';
  STICKY_HEIGHT = 33;
  STICKY_PADDING = 10;
  STICKY_FALLBACK_TEXT = document.lang === 'de' ? 'Inhalt' : 'Content';

  constructor(parent) {
    this.$parent = parent;
    this.$list = $('.jump-marks__list', this.$parent);
    this.$hiddenItems = $('.jump-marks__item--hidden', this.$list);
    this.$stickyList = $('.jump-marks__sticky', this.$parent);
    this.$stickyHeader = $('.accordion-head--heading', this.$stickyList);
    this.stuck = false;
    this.currentMark = null;
    this.isScrolling = false;
    this.offset = this.getListOffset();
    this.height = this.getListHeight();
    this.scrollTriggerPosition = 160;
    // store marks in two lists, one for the regular buttons and one for the
    // buttons in the sticky menu, so we end up like this:
    // [[list], [stickyList]]
    this.invalidMarks = [];
    this.marksLists = this.getMarks($$('button[data-to]', this.$parent));
    this.listAccordion = this.$hiddenItems
      ? new Shower({
          target: this.$hiddenItems,
          handler: $('.jump-marks__toggle button', this.$parent),
          easing: 'easeInOutQuart',
          duration: 400,
          cb: () => this.measure(),
        })
      : null;
    this.stickyListAccordion = new Shower({
      target: $('.accordion-body', this.$stickyList),
      handler: $('.accordion-head .toggle-button', this.$stickyList),
      easing: 'easeInOutQuart',
      duration: 400,
      initOpened: false,
      cb: dir => {
        if (dir === 'show') {
          this.$stickyList.classList.add('is-open');
        } else {
          this.$stickyList.classList.remove('is-open');
        }
      },
    });
  }

  getListOffset = () => getTopPosition(this.$list);

  getListHeight = () => this.$list.getBoundingClientRect().height;

  getMarks = marks => {
    const marksArr = marks
      // eslint-disable-next-line array-callback-return
      .map(mark => {
        const target = $(`#${mark.dataset.to}`);
        const title = $('.jump-marks__marker--label', mark).innerText; // Use innerText instead of textContent for ie11

        // return only marks with valid target
        if (target) {
          return {
            btn: mark,
            target,
            title,
            offset: getTopPosition(target),
          };
        } else {
          this.invalidMarks.push(mark);
        }
      })
      .filter(mark => mark);
    return splitByCondition(
      mark => closest(mark.btn, '.jump-marks__list--container'),
      marksArr
    );
  };

  getPrevMark = index => this.marksLists[0][index - 1];

  getNextMark = index => this.marksLists[0][index + 1];

  getMarkIndex = mark => this.marksLists[0].indexOf(mark);

  updateCurrentText = () => {
    this.$stickyHeader.innerText = this.currentMark
      ? this.currentMark.title
      : this.STICKY_FALLBACK_TEXT;
  };

  setCurrentMark = () => {
    const lessThanScrollPosList = this.marksLists[0].filter(mark => {
      return mark.offset - this.scrollTriggerPosition - 1 <= window.pageYOffset;
    });
    this.currentMark = lessThanScrollPosList.pop() || null;
    this.updateCurrentText();
  };

  setFocus = mark => {
    mark.target.setAttribute('tabindex', '0');
    mark.target.focus();
    mark.target.setAttribute('tabindex', '-1');
  };

  measure = () => {
    this.marksLists.map(list =>
      list.map(
        mark =>
          (mark.offset =
            getTopPosition(mark.target) -
            this.STICKY_HEIGHT -
            this.STICKY_PADDING)
      )
    );

    this.offset = this.getListOffset();
    this.height = this.getListHeight();
  };

  updateHash = mark => {
    const { id } = mark.target;
    const { hash } = window.location;
    if (`#${id}` === hash) return;
    // eslint-disable-next-line no-restricted-globals
    history.pushState(null, null, `#${id}`);
  };

  handleScroll = () => {
    this.marksLists[0][0] && this.checkSticky();
    this.stuck && this.setCurrentMark();
  };

  handleResize = () => {
    this.measure();
    this.marksLists[0][0] && this.checkSticky();
    this.stuck && this.setCurrentMark();
  };

  makeSticky = () => {
    this.$parent.classList.add(this.STICKY_CLASS);
    this.stuck = true;
  };

  onTransitionUpEnd = () => {
    this.$stickyList.removeEventListener(
      transitionEndEvent,
      this.onTransitionUpEnd
    );
    this.stickyListAccordion.isAnimating = false;
  };

  removeSticky = () => {
    this.$stickyList.addEventListener(
      transitionEndEvent,
      this.onTransitionUpEnd
    );
    this.$parent.classList.remove(this.STICKY_CLASS);
    this.stuck = false;
    this.stickyListAccordion.close();
  };

  checkSticky = () => {
    const pageOffset = window.pageYOffset || document.documentElement.scrollTop;

    if (this.marksLists[0][0]) {
      if (
        pageOffset >=
        this.marksLists[0][0].offset - this.scrollTriggerPosition
      ) {
        !this.stuck && this.makeSticky();
      } else {
        this.stuck && this.removeSticky();
      }
    } else {
      console.error('!this.marksLists[0][0]', this);
    }
  };

  scrollTo = offset => {
    // Make some room for the fixed logo
    const padTop = window.innerWidth > 600 ? 160 : 100;
    const distance = offset - padTop;
    this.isScrolling = true;
    aniScroll(distance, 1000, 'easeOutQuad', () => {
      this.isScrolling = false;
    });
  };

  handleListMarkClick = mark => {
    this.updateHash(mark);
    this.measure();
    this.scrollTo(mark.offset);
    // this.setFocus(mark);
  };

  handleStickyListMarkClick = mark => {
    this.updateHash(mark);
    this.measure();
    this.scrollTo(mark.offset);
    this.setFocus(mark);
    this.stickyListAccordion.close();
  };

  onBodyClick = event => {
    if (!this.stickyListAccordion.show) return;

    const { target } = event;
    const isJumpMarkSection = closest(target, '.jump-marks');

    if (isJumpMarkSection) return;
    this.stickyListAccordion.close();
  };

  bindEvents = () => {
    Bus.subscribe('scroll', 'JumpMarks', this.handleScroll);
    Bus.subscribe('resize', 'JumpMarks', this.handleResize);
    window.addEventListener('click', () => this.onBodyClick);

    const [list, stickyList] = this.marksLists;
    list.length &&
      list.forEach(mark =>
        mark.btn.addEventListener('click', () => this.handleListMarkClick(mark))
      );
    stickyList.length &&
      stickyList.forEach(mark =>
        mark.btn.addEventListener('click', () =>
          this.handleStickyListMarkClick(mark)
        )
      );

    this.invalidMarks.forEach(mark => mark.setAttribute('disabled', true));
  };

  init = () => {
    if (!this.$list) return;
    this.stickyListAccordion.init();
    this.listAccordion && this.listAccordion.init();
    this.marksLists[0][0] && this.checkSticky();
    this.stuck && this.setCurrentMark();
    this.bindEvents();
    $('body').classList.add('has-sticky');
    setTimeout(this.measure, 100);
  };
}

const jumpMarkSection = $('.jump-marks');
jumpMarkSection &&
  Bus.subscribe('DOMContentLoaded', 'JumpMarks', () => {
    jumpMarkSection && new JumpMarks(jumpMarkSection).init();
  });
